import { render, staticRenderFns } from "./PurchaseReturn.vue?vue&type=template&id=fc3c92d4"
import script from "./PurchaseReturn.vue?vue&type=script&lang=js"
export * from "./PurchaseReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports